<template>
  <div class="container">
    <div class="top">
      <Input
        placeholder="请输入联系人姓名"
        clearable
        style="width: 220px;margin-right: 8px"
        search
        v-model="searchtext"
        @on-change="searchCustomer"
      />
      <Button type="primary" ghost @click="$refs.EditCustomerContactDrawer.openDrawer()">添加联系人</Button>
    </div>
    <div class="page">
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadCustomerContact"
        show-total
        simple
        style="margin-right: 24px"
      />
    </div>
    <div class="customer-wrapper" ref="tableWrapper">
      <div :class="{selected:isActive == item._id}" v-for="item in customerContactList" @click="showCustomerDetail(item)" :key='item._id'>{{ item.name }}</div>
    </div>
    </Input>
    <EditCustomerContactDrawer ref="EditCustomerContactDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EditCustomerContactDrawer from "./EditCustomerContactDrawer.vue";

export default {
  name: "CustomerContactSidebar",
  components: {
    EditCustomerContactDrawer,
  },
  data() {
    return {
      searchtext: "",
      tableHeight: 300,
      page: 0,
      isActive: -1,
      limit: 15,
      filterQuery: {},
    };
  },
  computed: {
    ...mapState({
      totalRows: (state) => state.customerContact.totalCounts,
      customerContactList: (state) => state.customerContact.customerContactList,
    }),
    ...mapGetters({
      // getCustomerById: "customer/getCustomerById",
      getDetailCustomerById: "customer/getDetailCustomerById",
    }),
  },
  methods: {
    ...mapActions({
      getCustomerContact: "customerContact/getCustomerContactAction",
      getCustomerContactById: "customerContact/getCustomerContactByIdAction",
    }),
    async loadCustomerContact(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      try {
        this.tableLoading = true;
        await this.getCustomerContact(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.tableLoading = false;
      }
    },
    searchCustomer() {
      this.page = 0;
      this.loadCustomerContact();
    },
    async showCustomerDetail(item) {
      this.isActive = item._id;
      await this.getCustomerContactById(item._id)
    },
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
  created() {
    this.loadCustomerContact();
  },
};
</script>

<style scoped lang="stylus">
.container
  padding 25px 15px
  width 380px
  border-right 1px solid #c9c9c9

.customer-wrapper
  margin 15px 0
  overflow-y scroll
  height calc(100% - 48px)

  div
    cursor pointer
    font-size 15px
    margin 20px 0

.selected
  color #2D8CF0

.page
  display flex
  margin-top 15px
</style>